"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AudioPlayer["default"];
  }
});
var _AudioPlayer = _interopRequireDefault(require("./AudioPlayer"));